import {
  SET_TOAST,
  CLEAR_TOAST,
} from '../../actions/views/toast';

const INITIAL_STATE = {
  text: '',
  isOpen: false,
  toastType: 'err',
};

const Toast = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TOAST:
      return {
        ...state,
        text: action.text,
        isOpen: true,
        toastType: action.toastType,
      };
    case CLEAR_TOAST:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default Toast;
